import createDuck from '../../../lib/ducks/remoteDuck'
import Payment from '../../../lib/api/payment'

export default createDuck({
  namespace: 'payment',
  store: 'creditCards',
  fetchCallback: (option) => Payment.handleFetch(option),
})
